'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('../../../../@babel/runtime/helpers/esm/extends.js');
var objectWithoutProperties = require('../../../../@babel/runtime/helpers/esm/objectWithoutProperties.js');
var React = require('react');
var PropTypes = require('prop-types');
var clsx_m = require('../../../../clsx/dist/clsx.m.js');
var withStyles = require('../styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return n;
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var styles = {
  /* Styles applied to the root element. */
  root: {
    width: '100%',
    overflowX: 'auto'
  }
};
var TableContainer = React__namespace.forwardRef(function TableContainer(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      other = objectWithoutProperties(props, ["classes", "className", "component"]);

  return /*#__PURE__*/React__namespace.createElement(Component, _extends({
    ref: ref,
    className: clsx_m(classes.root, className)
  }, other));
});
process.env.NODE_ENV !== "production" ? TableContainer.propTypes = {
  /**
   * The table itself, normally `<Table />`
   */
  children: PropTypes__default["default"].node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes__default["default"].object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes__default["default"].string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes__default["default"].elementType
} : void 0;
var TableContainer$1 = withStyles(styles, {
  name: 'MuiTableContainer'
})(TableContainer);

exports["default"] = TableContainer$1;
exports.styles = styles;
